// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"042c94c9","358":"446371f1","453":"0aa43bfc","484":"64a5a2e0","551":"db58adac","672":"5a93f563","828":"044bf598","833":"113b7991","842":"5f892cc6","849":"4ede4c63","971":"4e7cc7e7","974":"66214210"}[chunkId] + ".chunk.js";
};